import React from 'react';

import Block from '../Block';

import styles from './Loader.scss';

/* eslint-disable */
export default () => <Block className={styles.wrapper} />;



// WEBPACK FOOTER //
// ./src/components/atoms/Loading/Loader.js